
import { Company } from "@/models/company";
import { CtepService } from "@/services/ctep-service";
import { Terminal } from "@/utils/ctep/terminal";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			unregisteredTerminals: [] as Terminal[],
			isFetching: false,
			isRegistering: false
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	methods: {
		async fetch(){
			if (this.isFetching) return;
			this.isFetching = true;
			try{
				this.unregisteredTerminals = await CtepService.getTerminalsWithNoOwner();
			}finally{
				this.isFetching = false;
			}
		},
		async registerTerminal(term:Terminal){
			if (this.isRegistering) return;
			this.isRegistering = true;
			try{
				await CtepService.registerTerminal(term.id, this.company.id);
				this.$emit("refresh");
				this.close();
			}finally{
				this.isFetching = false;
			}
		},
		async close(){
			this.$emit("close");
		}
	},
	created(){
		this.fetch();
	}
});
